import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AnimateOnScroll = ({ children, delay = 0, ease, duration = 0.5 }) => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });

  const variants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      transition={{
        duration,
        delay,
        ease: ease || [0.44, 0, 0.56, 1],
      }}
    >
      {children}
    </motion.div>
  );
};

export default AnimateOnScroll;
